/*
  routes.js
     define routes

*/

// route definitions
export const ROUTE_NAME = {
  ROUTE_LOGIN: 'Login',
  ROUTE_LOGIN_DUMMY: 'LoginDummy',
  ROUTE_MAIN_CONTENT: 'MainContent',
  ROUTE_WHEREABOUTS_LIST: 'WhereaboutsList',
  ROUTE_WHEREABOUTS_INFO: 'WhereaboutsInfo',
  ROUTE_MAP_LOCATION: 'MapLocation',
}
export const ROUTE_PATH = {
  ROUTE_LOGIN: '/' + ROUTE_NAME.ROUTE_LOGIN,
  ROUTE_LOGIN_DUMMY: '/' + ROUTE_NAME.ROUTE_LOGIN_DUMMY,
  ROUTE_MAIN_CONTENT: '/' + ROUTE_NAME.ROUTE_MAIN_CONTENT,
  ROUTE_WHEREABOUTS_LIST: '/' + ROUTE_NAME.ROUTE_WHEREABOUTS_LIST,
  ROUTE_WHEREABOUTS_INFO: '/' + ROUTE_NAME.ROUTE_WHEREABOUTS_INFO,
  ROUTE_WHEREABOUTS_INFO_ID: '/' + ROUTE_NAME.ROUTE_WHEREABOUTS_INFO + '/:id',
  ROUTE_MAP_LOCATION: '/' + ROUTE_NAME.ROUTE_MAP_LOCATION,
}



// WEBPACK FOOTER //
// ./src/router/routes.js